module.exports = __webpack_public_path__ + "img/cat-on-blanket.e6514431.jpg";